import { useContext } from 'react';

import { WhatsAppCallContext } from './whatsapp-call-context';

export function useWhatsAppCallContext() {
  const context = useContext(WhatsAppCallContext);
  if (!context) {
    // Return dummy fallback object when WhatsAppCallProvider is commented out/disabled
    return {
      calls: {},
      primaryCall: null,
      isBusy: false,
      startOutboundCall: () => {},
      acceptCall: () => {},
      rejectCall: () => {},
      hangUp: () => {},
      toggleMute: () => {},
      isMuted: () => false,
      toggleHold: () => {},
      isHeld: () => false,
      selectedMicrophoneId: '',
      setSelectedMicrophoneId: () => {},
      microphones: [],
    };
  }
  return context;
}
